var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('KeepAlive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_c('Banner',{directives:[{name:"show",rawName:"v-show",value:(_vm.ifShowBanner),expression:"ifShowBanner"}]}),_c('div',{staticStyle:{"display":"none"}},[_vm._v("1.0.1")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }